// This is the fixed markup that is applied to the price. Developed for Isracard project
const HIGH_PRICE_MARKUP = 1.12;

module.exports = {
    HIGH_PRICE_MARKUP,
};
